import styled from "styled-components";

export const UserDetailContainer = styled.div`
  display: flex;
  align-items: center;
  `;

export const UserName = styled.label`
  font-size: 14px;
  letter-spacing: 0.1em;
  font-weight: 500;
  color: #ffffff;
`;
